import { Injectable } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class ValidatorService {

  constructor() { }

  userNameValidator(control: FormControl) {
    const userName = control.value;
    if (userName) {
      const validMobile = /^[0-9]{10}$/.test(userName);

      // tslint:disable-next-line:max-line-length
      const validEmail = /^[a-zA-Z0-9.]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(userName);

      if (validEmail === true) {
        localStorage.setItem('username', 'email');
      }
      if (validMobile === true) {
        localStorage.setItem('username', 'number');
      }
      if (!(validMobile || validEmail)) {
        return {
          userNameValidation: {
            valid: false
          }
        };
      }
    }
    return null;
  }


  mobileNoValidator(control: FormControl) {
    const userName = control.value;
    if (userName) {
      const validMobile = /^[0-9]{10}$/.test(userName);
      if (!(validMobile)) {
        return {
          userNameValidation: {
            valid: false
          }
        };
      }
    }
    return null;
  }

  emailValidator(control: FormControl) {
    const userName = control.value;
    if (userName) {
      const validEmail = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(userName);
      if (!(validEmail)) {
        return {
          userNameValidation: {
            valid: false
          }
        };
      }
    }
    return null;
  }


  Passwordvalidator(control: FormControl) {
    const Password = control.value;
    if (Password) {
      const validPass = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{6,})/.test(Password);
      if (!(validPass)) {
        return {
          Passwordvalidator: {
            valid: false
          }
        };
      }
    }
    return null;
  }

  MustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (matchingControl.errors && !matchingControl.errors.mustMatch) {
        // return if another validator has already found an error on the matchingControl
        return;
      }

      // set error on matchingControl if validation fails
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }

  // public static omit_special_char(event) {
  //   const k = event.charCode;
  //   return ((k > 64 && k < 91) || (k > 96 && k < 123) || k === 8 || k === 32);
  // }

}
